import { Component } from "@angular/core";
import { IHeaderParams } from "ag-grid-community";
import { WizAgGrid } from "./wiz-ag-grid.component";
import { WIZ_EVENT_TYPE } from "@wizeoo/akm-core-lib";
import { WizEvent } from '../../../events/wiz-event';
import { WizEventManager } from '../../../events/wiz-event.manager';

@Component({
  selector: 'group-header-renderer',
  templateUrl: './groupheader.renderer.html',
  styleUrls: ['./groupheader.renderer.scss'],
})
export class GroupHeaderRenderer {
  
  public myIcon: string = 'reduce';
  
  private grid:  WizAgGrid<any> = null;

  private draw(): void {
    if(this.grid?.hiddenRows?.size > 0) {
      this.myIcon = 'creation';
    } else {
      this.myIcon = 'reduce';
    }
    // console.log('params', params);
  }

  agInit(params: IHeaderParams): void {
    this.grid = params['grid'];
    
    WizEventManager.addListener(this, this.grid, WIZ_EVENT_TYPE.ROW_GROUP_CHANGED, this.draw); 
    this.draw();
  }

  refresh(params: IHeaderParams): false {
    this.draw();
    return false;
  }

  public expand(): void {
    let expand: boolean = this.grid?.hiddenRows?.size > 0;

    WizEventManager.dispatchEvent(this.grid, new WizEvent(WIZ_EVENT_TYPE.ROW_GROUP_EXPAND, this.grid, expand));
    // console.log('expand', expand);
  }

}
